<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import { useFleetStore } from '@/stores/fleetStore'
import { useBattleSimulatorStore } from '@/stores/battleSimulatorStore'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const fleetStore = useFleetStore()
const battleSimulatorStore = useBattleSimulatorStore()

const selectedFleet = ref<number | null>(null)

const isDefending = computed(() => gameStore.modalType === 'battleSimulatorCopyDefendingFleet')

const sortedFleets = computed(() => {
  return [...fleetStore.fleets.values()].sort((a, b) => a.name.localeCompare(b.name))
})

const submit = () => {
  if (selectedFleet.value) {
    battleSimulatorStore.copyFromFleet(selectedFleet.value, isDefending.value ? 'defending' : 'attacking')
    gameStore.modalType = ''
  }
}
</script>

<template>
  <SmallModel :title="isDefending ? t('command.battleSimulator.copyToDefending') : t('command.battleSimulator.copyToAttacking')">
    <div class="p-2">
      <p class="pb-2 text-subtext">{{ t('command.battleSimulator.selectFleetToCopy', { type: isDefending ? t('command.battleSimulator.defending') : t('command.battleSimulator.attacking') }) }}</p>
      <select
        v-model="selectedFleet"
        @change="submit"
        class="w-full pointer-events-auto p-2 text-sm border rounded bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
      >
        <option :value="null" disabled>{{ t('command.battleSimulator.selectFleet') }}</option>
        <template v-for="fleet in sortedFleets" :key="fleet.id">
          <option :value="fleet.id">{{ fleet.name }} ({{ t('command.battleSimulator.ships', { count: fleet.nrOfShips }) }})</option>
        </template>
      </select>
      <p class="pt-2 text-subtext">{{ t('command.battleSimulator.replaceWarning', { type: isDefending ? t('command.battleSimulator.defending') : t('command.battleSimulator.attacking') }) }}</p>
    </div>
  </SmallModel>
</template>

<style scoped lang="scss"></style>
